:host {
  display: block;
}

.menu {
  padding: var(--sc-spacing-x-small) 0;

  &:focus {
    outline: none;
  }
}

::slotted(sc-input) {
  margin-top: -var(--sc-spacing-x-small);
}
::slotted(sc-divider) {
  --spacing: var(--sc-spacing-x-small);
}
